import { login, logout } from '../actions';
import { store } from '../store';
import { config } from '../config';
import axiosService from './Request';
import {ErrorRoutes} from "../constants";
const TOKEN_INFO_URL = "/api/token-check";

export class AuthenticateService {
    private static readonly POST_LOGIN_REDIRECT_KEY = 'redirect-atlas-pce';

    public static login(): void {
        let redirect: any;
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        redirect = urlParams.get('redirect');

        if (!token) {
            if (!window.location.pathname.startsWith(ErrorRoutes.UNAUTHORIZED)) {
                localStorage.setItem(this.POST_LOGIN_REDIRECT_KEY, window.location.href);
                window.location.href = ErrorRoutes.UNAUTHORIZED;
            }
        } else {
            localStorage.setItem("token-atlas-pce", token.toString());
            this.checkToken();

            if (redirect === null) {
                redirect = localStorage.getItem(this.POST_LOGIN_REDIRECT_KEY);
                localStorage.removeItem(this.POST_LOGIN_REDIRECT_KEY);
            }

            window.location = redirect as any;
        }
    }

    public static checkToken(): void {
        axiosService.get(`${TOKEN_INFO_URL}`, false)
            .then(function (response) {
                store.dispatch(login(response.data));
            });
    }

    public static logout(): boolean {
        localStorage.clear();
        store.dispatch(logout());
        window.location = config.apiUrl + '/saml/logout' as any;
        return true;
    }
}
